import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchBenefits } from "./benefits.thunks";

export const initialBenefitsFetch = createAsyncThunk(
    "benefits/initialFetch",
    async (_, { dispatch }) => {
        await dispatch(fetchBenefits()).unwrap();
        return true;
    }
);
